module.exports = __webpack_public_path__ + "static/media/logo.5d1aeb5c.svg";